import { render, staticRenderFns } from "./ChinaMap2.vue?vue&type=template&id=a26a511c"
import script from "./ChinaMap2.vue?vue&type=script&lang=js"
export * from "./ChinaMap2.vue?vue&type=script&lang=js"
import style0 from "./ChinaMap2.vue?vue&type=style&index=0&id=a26a511c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports